<template>
<v-select outlined v-model="unit" :items="availableUnits" :label="$t('configurations.report_unit')"></v-select>
</template>

<script>
export default {
  name: 'ReportUnitSelector',
  props: {
    value: {
      type: String
    },
    units: {
      type: Array
    }
  },
  computed: {
    unit: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    availableUnits() {
      return (this.units || []).map(u => ({
        text: this.$t(`unit.${u}`),
        value: u
      }));
    }
  }
}
</script>
